import { get } from 'lodash';

export const enableCAICSwitchToStandalone = get(window, 'newBillingConfig.enableCAICSwitchToStandalone', false);
